import { render, staticRenderFns } from "./moneyDoubleLayer.vue?vue&type=template&id=d8663ff6&scoped=true&"
import script from "./moneyDoubleLayer.vue?vue&type=script&lang=js&"
export * from "./moneyDoubleLayer.vue?vue&type=script&lang=js&"
import style0 from "./moneyDoubleLayer.vue?vue&type=style&index=0&id=d8663ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8663ff6",
  null
  
)

export default component.exports